// Scripted links editors may enter as External URL of a Link [D2C]. React
// blocks javascript: hrefs, so each one is rendered as the anchor below and
// run on click by <LinkActionHandler />. The External URL validation
// (infra/contentful migration 071) accepts exactly these values.
export const COOKIE_SETTINGS_HASH = "#cookie-settings";

const LINK_ACTION_HREFS: Record<string, string> = {
  "javascript:UC_UI.showSecondLayer()": COOKIE_SETTINGS_HASH,
};

export const LINK_ACTIONS: Record<string, () => void> = {
  [COOKIE_SETTINGS_HASH]: () => window.UC_UI?.showSecondLayer(),
};

export function isScriptedLink(url: string): boolean {
  return /^\s*javascript:/i.test(url);
}

/** Href standing in for a scripted link, undefined for an unknown one. */
export function linkActionHref(url: string): string | undefined {
  return LINK_ACTION_HREFS[url.trim()];
}
